import React__default from 'react';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const FormFieldPropertiesContext = React__default.createContext({});

export { FormFieldPropertiesContext as default };
